"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoPostActivationUpdateLimitOutcome = exports.CryptoUpdateLimitOptionsOutcome = exports.CryptoUpdateLimitError = void 0;
var CryptoUpdateLimitError;
(function (CryptoUpdateLimitError) {
    CryptoUpdateLimitError["notCryptoProduct"] = "Update limit is only available for crypto products";
    CryptoUpdateLimitError["notEligible"] = "Update limit is not available for this account";
    CryptoUpdateLimitError["onlyBeforeActivation"] = "Credit limit can only be updated before activation";
    CryptoUpdateLimitError["onlyAfterActivation"] = "This credit limit update is only available after activation";
    CryptoUpdateLimitError["collateralProvenanceRequired"] = "Collateral provenance must be recorded before confirming this credit limit";
    CryptoUpdateLimitError["uniqueViolationNoExistingCommitment"] = "Unexpected state: unique violation but no existing commitment";
})(CryptoUpdateLimitError || (exports.CryptoUpdateLimitError = CryptoUpdateLimitError = {}));
/**
 * Outcome of the updateLimit options step. Post-activation runs a real re-underwrite here (the
 * approved max line size depends on it), so it can deny — in which case an AAN is sent and no slider
 * is returned — hit a frozen Experian report on the soft pull, which the customer must unfreeze
 * before we can re-underwrite, or land in manual review (`underReview`) when the re-underwrite
 * prescribes a non-approval, non-denial status (e.g. humanInvestigate/ineligible) that carries no
 * AAN reasons. Pre-activation never re-underwrites in options and is always `available`.
 */
var CryptoUpdateLimitOptionsOutcome;
(function (CryptoUpdateLimitOptionsOutcome) {
    CryptoUpdateLimitOptionsOutcome["available"] = "available";
    CryptoUpdateLimitOptionsOutcome["denied"] = "denied";
    CryptoUpdateLimitOptionsOutcome["experianFrozen"] = "experianFrozen";
    CryptoUpdateLimitOptionsOutcome["underReview"] = "underReview";
})(CryptoUpdateLimitOptionsOutcome || (exports.CryptoUpdateLimitOptionsOutcome = CryptoUpdateLimitOptionsOutcome = {}));
/**
 * Outcome of a post-activation credit-limit increase confirm. Denial happens earlier, in the options
 * step (which runs the re-underwrite); by the time confirm is reached the increase is already approved
 * and only awaits the incremental BTC deposit.
 */
var CryptoPostActivationUpdateLimitOutcome;
(function (CryptoPostActivationUpdateLimitOutcome) {
    /** The higher limit is approved; it applies once the incremental BTC deposit confirms. */
    CryptoPostActivationUpdateLimitOutcome["approvedPendingDeposit"] = "approvedPendingDeposit";
    /**
     * The customer confirmed at their active line size (slider/input min), undoing a pending increase: both
     * post-activation gates are cleared and the account is back to its pre-confirm state. No deposit owed.
     */
    CryptoPostActivationUpdateLimitOutcome["canceledPendingIncrease"] = "canceledPendingIncrease";
})(CryptoPostActivationUpdateLimitOutcome || (exports.CryptoPostActivationUpdateLimitOutcome = CryptoPostActivationUpdateLimitOutcome = {}));
